import { gql } from '@common/hooks';
import {
  AssignmentSelectFragment,
  AssignmentSelectFragmentType,
} from '@pay-bill/graphql/fragments';

export const AssignmentInfosQuery = gql`
  query AssignmentInfos(
    $organizationId: ID
    $startDateBefore: ISO8601Date
    $endDateAfter: ISO8601Date
  ) {
    assignments: staffingRequestAssignments(
      organizationId: $organizationId
      startDateBefore: $startDateBefore
      endDateAfter: $endDateAfter
    ) {
      ...AssignmentSelectFragment
    }
  }
  ${AssignmentSelectFragment}
`;

export type AssignmentInfosQueryResponse = {
  assignments: AssignmentSelectFragmentType[];
};

export type AssignmentInfosQueryArgs = {
  organizationId: string;
  startDateBefore: string;
  endDateAfter: string;
};
